const MenuConf = {
  menuItems: [
    {
      id: "demo",
      pointer: ""
    },
    {
      id: "partners",
      pointer: "partners"
    },
    {
      id: "contact",
      pointer: "contact"
    }
  ]
};

export default MenuConf;



// WEBPACK FOOTER //
// ./src/containers/menu/MenuConf.js